import React from 'react';
import {TimersCtx, TimersCtxProvider} from 'components/dataProviders/tasks.reports.timers';
import {Accordion, AccordionSummary, AccordionDetails, Link} from '@material-ui/core';
import {RaymanUser, UserSize, Button} from 'components/core';
import {AccessTime, ExpandMore} from '@material-ui/icons';
import {makeStyles} from '@material-ui/core/styles';
import TimerDialog from './timerDialog';

const styles = makeStyles((theme) => ({
  timeRow: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    margin: "5px 0"
  },
  totalTime: {
    float: "right",
    '& svg': {
      width: "0.7em",
      verticalAlign: "bottom",
      margin: "0 5px 0 5px"
    }
  },
  noTimeRecords: {
    // float: "right",
    '& svg': {
      width: "0.7em",
      verticalAlign: "bottom",
      margin: "0 5px 0 5px"
    }
  },
  details: {
    flexDirection: "column"
  },
  timerDate: {
    padding: "3px 10px",
    fontSize: "12px",
    borderRadius: 4,
    backgroundColor: theme.palette.background.default,
  },
  link: {
    cursor: "pointer",
    alignSelf: "flex-start"
  }

}), {name: "RaymanTaskTimers"});

export default function MainContextWrapper({taskID, stepIndex, classes})
{
  if(!taskID) return null;

  return <TimersCtxProvider taskID={taskID} stepIndex={stepIndex}>
    <DataParser taskID={taskID} stepIndex={stepIndex} classes={classes}/>
  </TimersCtxProvider>
}

function DataParser({taskID, stepIndex})
{
    const ctx = React.useContext(TimersCtx);
    const [userData, setUserData] = React.useState(undefined);

    React.useEffect(function updateTimers()
    {
      if(ctx.loading) return;
      let newUserData = {};

      // Group timers by user ID
      ctx.data.array.forEach((timer) => {
        if(!newUserData[timer.userID])
        {
          newUserData[timer.userID] = {timers: [], total: 0};
        }

        newUserData[timer.userID].timers.push(timer);
        let diff = (timer.endDatetime ? new Date(timer.endDatetime) : new Date()) - new Date(timer.startDatetime);
        newUserData[timer.userID].timers[newUserData[timer.userID].timers.length - 1].totalTime = diff;
        newUserData[timer.userID].total += diff;
      });

      setUserData(newUserData);
      
    }, [ctx]);


    if(ctx.loading) return null;

    return <UserIterator userData = {userData} />
}

function UserIterator({userData})
{    
  const classes = styles();
    if(!userData || Object.keys(userData).length === 0) return <div className={classes.noTimeRecords}> <AccessTime /> No hay ningún registro de tiempo </div>;

    return <>
      {Object.keys(userData).map((userID) => <UserBlock key={userID} userID={parseInt(userID)} userData={userData[userID]} />)}
    </>
}

function UserBlock({userID, userData})
{
    const classes = styles();
    const [dialogOpen, setDialogOpen] = React.useState(false);

    function handleOpenDialog()
    {
      setDialogOpen(true);
    }

    function handleCloseDialog()
    {
      setDialogOpen(false);
    }


    return <>
      <TimerDialog userID={userID} open={dialogOpen} handleClose={handleCloseDialog} />
      <Accordion className={null} elevation={0}>
        <AccordionSummary expandIcon={<ExpandMore />}>
        <div className={classes.timeRow}><RaymanUser userID={userID} size={UserSize.size24} /> <MsToTimeBlock time={userData.total} /></div>
        </AccordionSummary>

        <AccordionDetails className={classes.details}>
          <Link className={classes.link} onClick={() => handleOpenDialog()}>Editar</Link>
          <TimerIterator timers={userData.timers}/>
        </AccordionDetails>
      </Accordion>
    </>
}

function TimerIterator({timers})
{
  
    return <>
      {timers.map((timer) => <React.Fragment key={timer.timerID}><TimerBlock timer={timer}/>{/* <Divider /> */}</React.Fragment>)}
    </>
}

function TimerBlock({timer})
{
  const classes = styles();
  return <div className={classes.timeRow}>
      <div className={classes.timerDate}>{new Date(timer.startDatetime).toLocaleString()}</div>
      <div>-</div>
      <div className={classes.timerDate}>{timer.endDatetime ? new Date(timer.endDatetime).toLocaleString() : "En curso"}</div>
      <MsToTimeBlock time={timer.totalTime} />
  </div>
}

function MsToTimeBlock({time})
{
  const classes = styles();
  let totalSecs = Math.floor(time / 1000);
  let hours = Math.floor(totalSecs / 3600);
  let mins = Math.floor((totalSecs - (hours * 3600)) / 60);
  let secs = Math.floor((totalSecs - (hours * 3600)) - (mins * 60));
  
  return <div className={classes.totalTime}><AccessTime />{`${hours < 10 ? 0 : ""}${hours}:${mins < 10 ? 0 : ""}${mins}:${secs < 10 ? 0 : ""}${secs}`}</div>
}

export {MsToTimeBlock}